import { useEffect } from 'react'
import { useLocation } from '@tanstack/react-router'
import { useEssentialStore } from '@/layouts/esssential.store'
import { initGa4, isInitialized, pageView } from '@/lib/gtm'

const GtmProvider = () => {
	const essentialStore = useEssentialStore()
	const pathname = useLocation({ select: (state) => state.pathname })
	useEffect(() => {
		if (essentialStore?.ga4ID) initGa4(essentialStore.ga4ID)
	}, [essentialStore.ga4ID])

	useEffect(() => {
		if (isInitialized()) pageView(pathname, document.title)
	}, [pathname])
	return <>{/* `GTM Provider Injected`*/}</>
}

export default GtmProvider
